import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from "@mui/material";

const ForcePrintDialog = ({ open, onCancel, onConfirm }) => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle sx={{ color: "#ff9800", fontWeight: 700 }}>
      Produtos não passaram pela verificação necessária
    </DialogTitle>
    <DialogContent>
      <Typography variant="body1" sx={{ mb: 2 }}>
        Alguns produtos não possuem código GTIN ou não foram validados. Tem
        certeza que deseja imprimir a etiqueta mesmo assim?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel} color="inherit">
        Cancelar
      </Button>
      <Button onClick={onConfirm} color="warning" variant="contained">
        Imprimir mesmo assim
      </Button>
    </DialogActions>
  </Dialog>
);

export default ForcePrintDialog;
